const appName = (): string =>
  document.querySelector<HTMLMetaElement>('meta[name="application-name"]')?.content ?? "LYTO"

export default appName
